<template>
  <canvas :width="width" :height="height" :id="id"></canvas>
</template>
<script>
import Chart from 'chart.js';

export default {
  props: [
    'id',
    'width',
    'height',
    'type',
    'title',
    'labels',
    'data',
    'fill',
    'options',
    'backgroundColor'
  ],
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      return this.data;
    },
    chartLabels() {
      return this.labels;
    }
  },
  mounted() {
    this.renderGraph();
  },
  watch: {
    data() {
      this.chart.destroy();
      this.renderGraph();
    },
    labels() {
      this.chart.destroy();
      this.renderGraph();
    }
  },
  methods: {
    renderGraph() {
      const defaultDataset = [
        {
          label: this.title,
          data: this.chartData,
          fill: this.fill,
          backgroundColor: this.backgroundColor
        }
      ];
      let customDataset = null;
      if (this.chartData.datasets?.length) {
        customDataset = this.chartData.datasets;
      }
      var ctx = document.getElementById(this.id).getContext('2d');
      this.chart = new Chart(ctx, {
        type: this.type ? this.type : 'bar',
        data: {
          labels: this.chartLabels,
          datasets: customDataset || defaultDataset
        },
        options: this.options
      });
    }
  }
};
</script>
